/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataStorageUnitKey } from './businessObjectDataStorageUnitKey';
import { StorageDirectory } from './storageDirectory';
import { StorageFile } from './storageFile';


export interface BusinessObjectDataStorageUnitCreateResponse { 
    businessObjectDataStorageUnitKey: BusinessObjectDataStorageUnitKey;
    storageDirectory?: StorageDirectory;
    /**
     * A container of various Storage Files that reside within a specific Storage Unit
     */
    storageFiles?: Array<StorageFile>;
}
